export default "__VITE_PUBLIC_ASSET__c9e491e9__"